import axios from "axios";
import {
  getApplicationId,
  getLocalToken,
  setUserSession,
  removeUserSession,
  getUserid,
} from "./common";
import createHttpError from "http-errors";

// import { CloudFront } from '@aws-sdk/client-cloudfront';

export const getapiurl = () => {
  return process.env.NODE_ENV === "development"
    ? process.env.REACT_APP_API_DEV_URL
    : process.env.REACT_APP_API_PROD_URL;
};

export const getAppId = () => {
  return getApplicationId();
};

export const getAppParams = () => {
  return "https://smottstorage.s3.us-east-2.amazonaws.com/";
};

export const getAllImages = async (limit, skip) => {
  const url = getapiurl();
  const aws = "api/aws/";
  const requestName = "/imageAll";
  const appid = getAppId();
  const getUrl =
    url + aws + appid + requestName + "?limit=" + limit + "&skip=" + skip;

  const resp = await axios
    .get(getUrl)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};

export const serachAllImages = async (limit, skip, query) => {
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const url = getapiurl();
  const aws = "api/aws/";
  const requestName = "/searchImages";
  const appid = getAppId();
  const getUrl =
    url +
    aws +
    appid +
    requestName +
    "?limit=" +
    limit +
    "&skip=" +
    skip +
    "&query=" +
    query;

  const resp = await axios
    .get(getUrl, { headers: { Authorization: token } })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};

export const getAllFiles = async (limit, skip) => {
  const url = getapiurl();
  const aws = "api/aws/";
  const requestName = "/fileAll";
  const appid = getAppId();
  const getUrl =
    url + aws + appid + requestName + "?limit=" + limit + "&skip=" + skip;

  const resp = await axios
    .get(getUrl)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};

export const getUserApi = async (email, password) => {
  const api_url = getapiurl() + "api/user/login";

  const token_set = await axios
    .post(api_url, {
      email: email,
      password: password,
    })
    .then(
      (response) => {
        return response;
      },
      (error) => {
        return error.response;
      }
    );
  return token_set;
};
export const getVCMS = async () => {
  const api_url = getapiurl() + "api/vcms/" + getAppId() + "/getVideoCloud";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const resp = await axios
    .get(api_url, { headers: { Authorization: token } })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};

export const editVCMS = async (editing) => {
  const api_url = getapiurl() + "api/vcms/" + getAppId() + "/editVideoCloud";
  const token = getLocalToken();
  if (!token) {
    return;
  }

  const token_set = await axios
    .put(
      api_url,
      {
        cloudName: editing.cloudName,
        cloudKey: editing.cloudKey,
        cloudSecret: editing.cloudSecret,
        cloudKeyV2: editing.cloudKeyV2,
        cloudSecretV2: editing.cloudSecretV2,
        mainAccountId: editing.mainAccountId,
        secondAccountId: editing.secondAccountId,
        firstPlayer: editing.firstPlayer,
        secondPlayer: editing.secondPlayer,
        premiumPlayer: editing.premiumPlayer,
        licenseKey: editing.licenseKey,
        iosLicenseKey: editing.iosLicenseKey || null,
        premLicenseKey: editing.premLicenseKey || null,
        iosPremLicenseKey: editing.iosPremLicenseKey || null,
        secLicenseKey: editing.secLicenseKey || null,
        iosSecLicenseKey: editing.iosSecLicenseKey || null,
        drmKey: editing.drmKey,
        drmMobileKey: editing.drmMobileKey,
        drmTVKey: editing.drmTVKey,
        searchPlaylist: editing.searchPlaylist,
        watchPlaylist: editing.watchPlaylist,
        recommendedPlaylist: editing.recommendedPlaylist,
      },
      { headers: { Authorization: token } }
    )
    .then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};

export const requestPublish = async (editing) => {
  const app_id = getAppId();
  const api_url = getapiurl() + "api/layout/" + app_id + "/createNotification";
  const token = getLocalToken();
  if (!token) {
    return;
  }

  const token_set = await axios
    .post(
      api_url,
      {
        itemtype: editing.itemtype,
        itemid: editing.itemid,
        redirect: editing.redirect,
        message: editing.message,
        read: true,
      },
      { headers: { Authorization: token } }
    )
    .then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};

export const markRead = async (editing) => {
  const api_url = getapiurl() + "api/layout/" + editing + "/editNotification";
  const token = getLocalToken();
  if (!token) {
    return;
  }

  const token_set = await axios
    .put(
      api_url,
      {
        read: false,
      },
      { headers: { Authorization: token } }
    )
    .then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};

export const getNotification = async () => {
  const app_id = getAppId();
  const api_url = getapiurl() + "api/layout/" + app_id + "/getNotification";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const resp = await axios
    .get(api_url, { headers: { Authorization: token } })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};

export const createVCMS = async (editing) => {
  const api_url = getapiurl() + "api/vcms/" + getAppId() + "/createVideoCloud";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const token_set = await axios
    .post(
      api_url,
      {
        cloudName: editing.cloudName,
        cloudKey: editing.cloudKey,
        liveCloudName: editing.liveCloudName,
        cloudSecret: editing.cloudSecret,
        cloudKeyV2: editing.cloudKeyV2,
        cloudSecretV2: editing.cloudSecretV2,
        mainAccountId: editing.mainAccountId,
        secondAccountId: editing.secondAccountId,
        firstPlayer: editing.firstPlayer,
        secondPlayer: editing.secondPlayer,
        premiumPlayer: editing.premiumPlayer,
        licenseKey: editing.licenseKey,
        iosLicenseKey: editing.iosLicenseKey || null,
        premLicenseKey: editing.premLicenseKey || null,
        iosPremLicenseKey: editing.iosPremLicenseKey || null,
        secLicenseKey: editing.secLicenseKey || null,
        iosSecLicenseKey: editing.iosSecLicenseKey || null,
        drmKey: editing.drmKey,
        drmMobileKey: editing.drmMobileKey,
        drmTVKey: editing.drmTVKey,
        searchPlaylist: editing.searchPlaylist,
        watchPlaylist: editing.watchPlaylist,
        recommendedPlaylist: editing.recommendedPlaylist,
      },
      { headers: { Authorization: token } }
    )
    .then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};

export const publishVCMS = async () => {
  const api_url =
    getapiurl() + "api/publish/" + getAppId() + "/publishVideoCloud";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const token_set = await axios
    .post(api_url, {}, { headers: { Authorization: token } })
    .then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};

export const alrayyanSwitching = async (aName, stream) => {
  const api_url =
    "https://vpiy2u79n3.execute-api.us-east-2.amazonaws.com/prod/switch-stream?chname=" +
    aName +
    "&switchto=" +
    stream;
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const token_set = await axios.get(api_url).then(
    (response) => {
      return response;
    },
    (error) => {
      throw error;
    }
  );
  return token_set;
};

export const getAlrayyanStatus = async (url) => {
  const api_url = url;

  const resp = await axios
    .get(api_url)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};

export const getColor = async () => {
  const api_url = getapiurl() + "api/layout/" + getAppId() + "/getColor";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const resp = await axios
    .get(api_url, { headers: { Authorization: token } })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};

export const publishColors = async () => {
  const api_url = getapiurl() + "api/publish/" + getAppId() + "/publishColors";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const resp = await axios
    .post(api_url, {}, { headers: { Authorization: token } })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};

export const editColor = async (editing) => {
  const api_url = getapiurl() + "api/layout/" + getAppId() + "/editColor";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const token_set = await axios
    .put(
      api_url,
      {
        primaryBackgroundColor: editing.primaryBackgroundColor,
        secondaryBackgroundColor: editing.secondaryBackgroundColor,
        primaryTextColor: editing.primaryTextColor,
        secondaryTextColor: editing.secondaryTextColor,
        primaryHighlightColor: editing.primaryHighlightColor,
        secondaryHighlightColor: editing.secondaryHighlightColor,
        menuBackgroundColor: editing.menuBackgroundColor,
        elementBackgroundColor: editing.elementBackgroundColor,
        elementForegroundColor: editing.elementForegroundColor,
        buttonBackgroundColor: editing.buttonBackgroundColor,
        buttonForegroundColor: editing.buttonForegroundColor,
        menuForegroundColor: editing.menuForegroundColor,
        textShadow: editing.textShadow,
        dark: editing.dark,
      },
      { headers: { Authorization: token } }
    )
    .then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};

export const createColor = async (editing) => {
  const api_url = getapiurl() + "api/layout/" + getAppId() + "/createColor";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const token_set = await axios
    .post(
      api_url,
      {
        primaryBackgroundColor: editing.primaryBackgroundColor,
        secondaryBackgroundColor: editing.secondaryBackgroundColor,
        primaryTextColor: editing.primaryTextColor,
        secondaryTextColor: editing.secondaryTextColor,
        primaryHighlightColor: editing.primaryHighlightColor,
        secondaryHighlightColor: editing.secondaryHighlightColor,
        menuBackgroundColor: editing.menuBackgroundColor,
        elementBackgroundColor: editing.elementBackgroundColor,
        elementForegroundColor: editing.elementForegroundColor,
        buttonBackgroundColor: editing.buttonBackgroundColor,
        buttonForegroundColor: editing.buttonForegroundColor,
        menuForegroundColor: editing.menuForegroundColor,
        textShadow: editing.textShadow,
        dark: editing.dark,
      },
      { headers: { Authorization: token } }
    )
    .then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};

export const createPage = async (editing) => {
  const api_url = getapiurl() + "api/layout/" + getAppId() + "/createPage";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const token_set = await axios
    .post(
      api_url,
      {
        pageType: editing.pageType,
        referenceName: editing.referenceName,
        urlName: editing.urlName || "",
        displayName: editing.displayName || "",
        portraitThumbnail: editing.portraitThumbnail || "",
        landscapeThumbnail: editing.landscapeThumbnail || "",
        bannerImage: editing.bannerImage || "",
        genre: editing.genre || "",
        starring: editing.starring || "",
        rating: editing.rating || "",
        ageRating: editing.ageRating || "",
        description: editing.description || "",
        author: editing.author || "",
        publishDate: editing.publishDate || "",
        mainHeader: editing.mainHeader || "",
        externalPage: editing.externalPage || "",
        livePage: editing.livePage || "",
        internalPage: editing.internalPage || "",
        blockQuote: editing.blockQuote || "",
        sectionHeader1: editing.sectionHeader1 || "",
        sectionHeader2: editing.sectionHeader2 || "",
        introduction: editing.introduction || "",
        sectionDescription1: editing.sectionDescription1 || "",
        sectionDescription2: editing.sectionDescription2 || "",
        contentType: editing.contentType || "",
        premiumType: editing.premiumType || "",
        videoId: editing.videoId || "",
        audio: editing.audio || "",
        devices: editing.devices || [],
        items: editing.items || [],
        draftStatus: editing.draftStatus || true,
        publishStatus: editing.publishStatus || false,
        republishStatus: editing.republishStatus || false,
        director: editing.director || null,
        cite: editing.cite || null,
        writer: editing.writer || null,
        studio: editing.studio || null,
        producer: editing.producer || null,
        tag: editing.tag || null,
        firstTag: editing.firstTag || null,
        secondTag: editing.secondTag || null,
        recommendation: editing.recommendation || null,
        createdBy: getUserid(),
        editedBy: getUserid(),
      },
      { headers: { Authorization: token } }
    )
    .then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};

export const createPageInElement = async (editing, ElementID) => {
  const api_url =
    getapiurl() +
    "api/layout/" +
    getAppId() +
    "/" +
    ElementID +
    "/createPageInElement";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const token_set = await axios
    .post(
      api_url,
      {
        pageType: editing.pageType,
        referenceName: editing.referenceName,
        urlName: editing.urlName || "",
        displayName: editing.displayName || "",
        portraitThumbnail: editing.portraitThumbnail || "",
        landscapeThumbnail: editing.landscapeThumbnail || "",
        bannerImage: editing.bannerImage || "",
        genre: editing.genre || "",
        starring: editing.starring || "",
        rating: editing.rating || "",
        ageRating: editing.ageRating || "",
        description: editing.description || "",
        author: editing.author || "",
        publishDate: editing.publishDate || "",
        mainHeader: editing.mainHeader || "",
        externalPage: editing.externalPage || "",
        livePage: editing.livePage || "",
        internalPage: editing.internalPage || "",
        blockQuote: editing.blockQuote || "",
        sectionHeader1: editing.sectionHeader1 || "",
        sectionHeader2: editing.sectionHeader2 || "",
        introduction: editing.introduction || "",
        sectionDescription1: editing.sectionDescription1 || "",
        sectionDescription2: editing.sectionDescription2 || "",
        contentType: editing.contentType || "",
        premiumType: editing.premiumType || "",
        videoId: editing.videoId || "",
        audio: editing.audio || "",
        devices: editing.devices || [],
        items: editing.items || [],
        draftStatus: editing.draftStatus || true,
        publishStatus: editing.publishStatus || false,
        republishStatus: editing.republishStatus || false,
        director: editing.director || null,
        cite: editing.cite || null,
        writer: editing.writer || null,
        studio: editing.studio || null,
        producer: editing.producer || null,
        tag: editing.tag || null,
        firstTag: editing.firstTag || null,
        secondTag: editing.secondTag || null,
        recommendation: editing.recommendation || null,
        createdBy: getUserid(),
        editedBy: getUserid(),
      },
      { headers: { Authorization: token } }
    )
    .then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};

export const editPage = async (editing, pageid) => {
  const api_url = getapiurl() + "api/layout/" + pageid + "/editPage";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const token_set = await axios
    .put(
      api_url,
      {
        referenceName: editing.referenceName,
        urlName: editing.urlName,
        displayName: editing.displayName,
        portraitThumbnail: editing.portraitThumbnail,
        landscapeThumbnail: editing.landscapeThumbnail,
        bannerImage: editing.bannerImage,
        genre: editing.genre,
        starring: editing.starring,
        rating: editing.rating,
        ageRating: editing.ageRating,
        description: editing.description,
        author: editing.author,
        publishDate: editing.publishDate,
        mainHeader: editing.mainHeader,
        externalPage: editing.externalPage,
        livePage: editing.livePage,
        internalPage: editing.internalPage,
        blockQuote: editing.blockQuote,
        sectionHeader1: editing.sectionHeader1,
        sectionHeader2: editing.sectionHeader2,
        introduction: editing.introduction,
        sectionDescription1: editing.sectionDescription1,
        sectionDescription2: editing.sectionDescription2,
        contentType: editing.contentType,
        premiumType: editing.premiumType,
        videoId: editing.videoId,
        cite: editing.cite,
        audio: editing.audio,
        devices: editing.devices,
        items: editing.items,
        draftStatus: editing.draftStatus,
        publishStatus: editing.publishStatus,
        republishStatus: editing.republishStatus || false,
        director: editing.director || null,
        writer: editing.writer || null,
        recommendation: editing.recommendation || null,
        studio: editing.studio || null,
        producer: editing.producer || null,
        tag: editing.tag || null,
        firstTag: editing.firstTag || null,
        secondTag: editing.secondTag || null,
        editedBy: getUserid(),
      },
      { headers: { Authorization: token } }
    )
    .then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};

export const redraftPage = async (editing, pageid) => {
  const api_url = getapiurl() + "api/layout/" + pageid + "/reEditPage";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const token_set = await axios
    .put(
      api_url,
      {
        referenceName: editing.referenceName,
        urlName: editing.urlName,
        displayName: editing.displayName,
        portraitThumbnail: editing.portraitThumbnail,
        landscapeThumbnail: editing.landscapeThumbnail,
        bannerImage: editing.bannerImage,
        genre: editing.genre,
        starring: editing.starring,
        rating: editing.rating,
        ageRating: editing.ageRating,
        description: editing.description,
        author: editing.author,
        publishDate: editing.publishDate,
        mainHeader: editing.mainHeader,
        externalPage: editing.externalPage,
        livePage: editing.livePage,
        internalPage: editing.internalPage,
        blockQuote: editing.blockQuote,
        sectionHeader1: editing.sectionHeader1,
        sectionHeader2: editing.sectionHeader2,
        introduction: editing.introduction,
        sectionDescription1: editing.sectionDescription1,
        sectionDescription2: editing.sectionDescription2,
        contentType: editing.contentType,
        premiumType: editing.premiumType,
        videoId: editing.videoId,
        cite: editing.cite,
        audio: editing.audio,
        devices: editing.devices,
        items: editing.items,
        draftStatus: editing.draftStatus,
        publishStatus: editing.publishStatus,
        republishStatus: editing.republishStatus || false,
        director: editing.director || null,
        writer: editing.writer || null,
        recommendation: editing.recommendation || null,
        studio: editing.studio || null,
        producer: editing.producer || null,
        tag: editing.tag || null,
        firstTag: editing.firstTag || null,
        secondTag: editing.secondTag || null,
        editedBy: getUserid(),
      },
      { headers: { Authorization: token } }
    )
    .then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};

export const publishPage = async (pageid) => {
  const api_url =
    getapiurl() + "api/publish/" + getAppId() + "/" + pageid + "/publishPage";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const token_set = await axios
    .post(api_url, {}, { headers: { Authorization: token } })
    .then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};

export const republishPage = async (pageid) => {
  const api_url =
    getapiurl() + "api/publish/" + getAppId() + "/" + pageid + "/rePublishPage";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const token_set = await axios
    .post(api_url, {}, { headers: { Authorization: token } })
    .then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};

export const unpublishPage = async (pageid) => {
  const api_url =
    getapiurl() + "api/publish/" + getAppId() + "/" + pageid + "/unPublishPage";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const token_set = await axios
    .post(api_url, {}, { headers: { Authorization: token } })
    .then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};

export const createElement = async (editing) => {
  const api_url = getapiurl() + "api/layout/" + getAppId() + "/createElement";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const token_set = await axios
    .post(
      api_url,
      {
        elementType: editing.elementType,
        referenceName: editing.referenceName,
        urlName: editing.urlName,
        portraitThumbnail: editing.portraitThumbnail,
        landscapeThumbnail: editing.landscapeThumbnail,
        bannerImage: editing.bannerImage,
        displayName: editing.displayName,
        displayNameVisibility: editing.displayNameVisibility,
        viewAllText: editing.viewAllText,
        viewAllVisibility: editing.viewAllVisibility,
        viewAllPage: editing.viewAllPage,
        playlistId: editing.playlistId,
        tabType: editing.tabType,
        tab1Name: editing.tab1Name,
        tab2Name: editing.tab2Name,
        tab3Name: editing.tab3Name,
        tab1Container: editing.tab1Container,
        tab2Container: editing.tab2Container,
        tab3Container: editing.tab3Container,
        devices: editing.devices,
        items: editing.items,
        draftStatus: editing.draftStatus,
        publishStatus: editing.publishStatus,
        republishStatus: editing.republishStatus || false,
        autoPlay: editing.autoPlay,
        autoPlayTimer: editing.autoPlayTimer,
        createdBy: getUserid(),
        editedBy: getUserid(),
      },
      { headers: { Authorization: token } }
    )
    .then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};

export const createElementInPage = async (editing, pageId) => {
  const api_url =
    getapiurl() +
    "api/layout/" +
    getAppId() +
    "/" +
    pageId +
    "/createElementInPage";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const token_set = await axios
    .post(
      api_url,
      {
        elementType: editing.elementType,
        referenceName: editing.referenceName,
        urlName: editing.urlName,
        urlPage: editing.urlPage,
        portraitThumbnail: editing.portraitThumbnail,
        landscapeThumbnail: editing.landscapeThumbnail,
        bannerImage: editing.bannerImage,
        displayName: editing.displayName,
        displayNameVisibility: editing.displayNameVisibility,
        viewAllText: editing.viewAllText,
        viewAllVisibility: editing.viewAllVisibility,
        viewAllPage: editing.viewAllPage,
        playlistId: editing.playlistId,
        tabType: editing.tabType,
        tab1Name: editing.tab1Name,
        tab2Name: editing.tab2Name,
        tab3Name: editing.tab3Name,
        tab1Container: editing.tab1Container,
        tab2Container: editing.tab2Container,
        tab3Container: editing.tab3Container,
        devices: editing.devices,
        items: editing.items,
        draftStatus: editing.draftStatus,
        publishStatus: editing.publishStatus,
        republishStatus: editing.republishStatus || false,
        autoPlay: editing.autoPlay,
        autoPlayTimer: editing.autoPlayTimer,
        createdBy: getUserid(),
        editedBy: getUserid(),
      },
      { headers: { Authorization: token } }
    )
    .then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};

export const editElement = async (editing, pageid) => {
  const api_url = getapiurl() + "api/layout/" + pageid + "/editElement";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const token_set = await axios
    .put(
      api_url,
      {
        referenceName: editing.referenceName,
        urlName: editing.urlName,
        urlPage: editing.urlPage,
        channels: editing.channels,
        epg: editing.epg,
        portraitThumbnail: editing.portraitThumbnail,
        landscapeThumbnail: editing.landscapeThumbnail,
        bannerImage: editing.bannerImage,
        displayName: editing.displayName,
        displayNameVisibility: editing.displayNameVisibility,
        viewAllText: editing.viewAllText,
        viewAllVisibility: editing.viewAllVisibility,
        viewAllPage: editing.viewAllPage,
        playlistId: editing.playlistId,
        tabType: editing.tabType,
        tab1Name: editing.tab1Name,
        tab2Name: editing.tab2Name,
        tab3Name: editing.tab3Name,
        tab1Container: editing.tab1Container,
        tab2Container: editing.tab2Container,
        tab3Container: editing.tab3Container,
        devices: editing.devices,
        items: editing.items,
        draftStatus: editing.draftStatus,
        publishStatus: editing.publishStatus,
        republishStatus: editing.republishStatus || false,
        autoPlay: editing.autoPlay,
        autoPlayTimer: editing.autoPlayTimer,
        editedBy: getUserid(),
      },
      { headers: { Authorization: token } }
    )
    .then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};

export const redraftElement = async (editing, pageid) => {
  const api_url = getapiurl() + "api/layout/" + pageid + "/reEditElement";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const token_set = await axios
    .put(
      api_url,
      {
        referenceName: editing.referenceName,
        urlName: editing.urlName,
        portraitThumbnail: editing.portraitThumbnail,
        landscapeThumbnail: editing.landscapeThumbnail,
        bannerImage: editing.bannerImage,
        displayName: editing.displayName,
        displayNameVisibility: editing.displayNameVisibility,
        viewAllText: editing.viewAllText,
        viewAllVisibility: editing.viewAllVisibility,
        viewAllPage: editing.viewAllPage,
        playlistId: editing.playlistId,
        tabType: editing.tabType,
        tab1Name: editing.tab1Name,
        tab2Name: editing.tab2Name,
        tab3Name: editing.tab3Name,
        tab1Container: editing.tab1Container,
        tab2Container: editing.tab2Container,
        tab3Container: editing.tab3Container,
        devices: editing.devices,
        items: editing.items,
        draftStatus: editing.draftStatus,
        publishStatus: editing.publishStatus,
        republishStatus: editing.republishStatus || false,
        autoPlay: editing.autoPlay,
        autoPlayTimer: editing.autoPlayTimer,
        editedBy: getUserid(),
      },
      { headers: { Authorization: token } }
    )
    .then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};

export const publishElement = async (pageid) => {
  const api_url =
    getapiurl() +
    "api/publish/" +
    getAppId() +
    "/" +
    pageid +
    "/publishElement";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const token_set = await axios
    .post(api_url, {}, { headers: { Authorization: token } })
    .then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};

export const republishElement = async (pageid) => {
  const api_url =
    getapiurl() +
    "api/publish/" +
    getAppId() +
    "/" +
    pageid +
    "/rePublishElement";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const token_set = await axios
    .post(api_url, {}, { headers: { Authorization: token } })
    .then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};

export const unpublishElement = async (pageid) => {
  const api_url =
    getapiurl() +
    "api/publish/" +
    getAppId() +
    "/" +
    pageid +
    "/unPublishElement";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const token_set = await axios
    .post(api_url, {}, { headers: { Authorization: token } })
    .then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};

export const editBranding = async (editing) => {
  const api_url = getapiurl() + "api/layout/" + getAppId() + "/editBranding";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const token_set = await axios
    .put(
      api_url,
      {
        mainLogo: editing.mainLogo,
        footerLogo: editing.footerLogo,
        iconLogo: editing.iconLogo,
        appIcon: editing.appIcon,
        marketingLogo: editing.marketingLogo,
        tvLogo: editing.tvLogo,
        chromeCastLogo: editing.chromeCastLogo,
        mobileLogo: editing.mobileLogo,
        mainDarkLogo: editing.mainDarkLogo,
        footerDarkLogo: editing.footerDarkLogo,
        tvDarkLogo: editing.tvDarkLogo,
        chromeCastDarkLogo: editing.chromeCastDarkLogo,
        mobileDarkLogo: editing.mobileDarkLogo,
      },
      { headers: { Authorization: token } }
    )
    .then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};

export const createBranding = async (editing) => {
  const api_url = getapiurl() + "api/layout/" + getAppId() + "/createBranding";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const token_set = await axios
    .post(
      api_url,
      {
        mainLogo: editing.mainLogo,
        footerLogo: editing.footerLogo,
        iconLogo: editing.iconLogo,
        appIcon: editing.appIcon,
        marketingLogo: editing.marketingLogo,
        tvLogo: editing.tvLogo,
        chromeCastLogo: editing.chromeCastLogo,
        mobileLogo: editing.mobileLogo,
        mainDarkLogo: editing.mainDarkLogo,
        footerDarkLogo: editing.footerDarkLogo,
        tvDarkLogo: editing.tvDarkLogo,
        chromeCastDarkLogo: editing.chromeCastDarkLogo,
        mobileDarkLogo: editing.mobileDarkLogo,
      },
      { headers: { Authorization: token } }
    )
    .then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};

export const publishBranding = async () => {
  const api_url =
    getapiurl() + "api/publish/" + getAppId() + "/publishBranding";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const token_set = await axios
    .post(api_url, {}, { headers: { Authorization: token } })
    .then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};

export const getBranding = async () => {
  const api_url = getapiurl() + "api/layout/" + getAppId() + "/getBranding";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const resp = await axios
    .get(api_url, { headers: { Authorization: token } })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });

  return resp;
};

export const getImagesByKey = async (key) => {
  const url = getapiurl();
  const aws = "api/aws/";
  const requestName = "/imageKey";
  const getUrl = url + aws + key + requestName;

  const resp = await axios
    .get(getUrl)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};
export const getImagesById = async (key) => {
  const url = getapiurl();
  const aws = "api/aws/";
  const requestName = "/getImage";
  const getUrl = url + aws + key + requestName;

  const resp = await axios
    .get(getUrl)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};

export const getFilesById = async (key) => {
  const url = getapiurl();
  const aws = "api/aws/";
  const requestName = "/getFile";
  const getUrl = url + aws + key + requestName;

  const resp = await axios
    .get(getUrl)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};
export const deleteImage = async (key) => {
  const url = getapiurl();
  const aws = "api/aws/";
  const requestName = "/deleteImage";
  const getUrl = url + aws + key + requestName;
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const resp = await axios
    .delete(getUrl, { headers: { Authorization: token } })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};

export const deleteFile = async (key) => {
  const url = getapiurl();
  const aws = "api/aws/";
  const requestName = "/deleteFile";
  const getUrl = url + aws + key + requestName;
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const resp = await axios
    .delete(getUrl, { headers: { Authorization: token } })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};

export const getPage = async (pageid) => {
  const api_url = getapiurl() + "api/layout/" + pageid + "/getPage";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const resp = await axios
    .get(api_url, { headers: { Authorization: token } })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });

  return resp;
};

export const getElementDetail = async (pageid) => {
  let idQuery = "";
  /* eslint-disable no-unused-vars */
  const id_full = pageid.map((item, index) => {
    pageid.length !== index + 1
      ? (idQuery += item.itemid + "&id=")
      : (idQuery += item.itemid);
    return index;
  });
  const api_url = getapiurl() + "api/layout/getElemGroup/?id=" + idQuery;
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const resp = await axios
    .get(api_url, { headers: { Authorization: token } })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });

  return resp;
};

export const getElementRefDetail = async (pageid) => {
  const api_url = getapiurl() + "api/layout/" + pageid + "/getElementArray";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const resp = await axios
    .get(api_url, { headers: { Authorization: token } })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });

  return resp;
};

export const getPageRefDetail = async (pageid) => {
  const api_url = getapiurl() + "api/layout/" + pageid + "/getPageArray";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const resp = await axios
    .get(api_url, { headers: { Authorization: token } })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });

  return resp;
};

export const getTabRefDetail = async (pageid) => {
  const api_url = getapiurl() + "api/layout/" + pageid + "/getTabArray";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const resp = await axios
    .get(api_url, { headers: { Authorization: token } })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });

  return resp;
};

export const getPageDetail = async (pageid) => {
  let idQuery = "";
  /* eslint-disable no-unused-vars */
  const id_full = pageid.map((item, index) => {
    pageid.length !== index + 1
      ? (idQuery += item.itemid + "&id=")
      : (idQuery += item.itemid);
    return index;
  });
  const api_url = getapiurl() + "api/layout/getPageGroup/?id=" + idQuery;
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const resp = await axios
    .get(api_url, { headers: { Authorization: token } })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });

  return resp;
};

export const getAllPages = async (limit, skip) => {
  const url = getapiurl();
  const aws = "api/layout/";
  const requestName = "/getAllPages";
  const appid = getAppId();
  const getUrl =
    url + aws + appid + requestName + "?limit=" + limit + "&skip=" + skip;
  const token = getLocalToken();
  if (!token) {
    return;
  }

  const resp = await axios
    .get(getUrl, { headers: { Authorization: token } })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};

export const getAllSearchPages = async (limit, skip, query) => {
  const url = getapiurl();
  const aws = "api/layout/";
  const requestName = "/getSearchPages";
  const appid = getAppId();
  const getUrl =
    url +
    aws +
    appid +
    requestName +
    "?limit=" +
    limit +
    "&skip=" +
    skip +
    "&query=" +
    query;
  const token = getLocalToken();
  if (!token) {
    return;
  }

  const resp = await axios
    .get(getUrl, { headers: { Authorization: token } })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};

export const getAllSearchElements = async (limit, skip, query) => {
  const url = getapiurl();
  const aws = "api/layout/";
  const requestName = "/getSearchElements";
  const appid = getAppId();
  const getUrl =
    url +
    aws +
    appid +
    requestName +
    "?limit=" +
    limit +
    "&skip=" +
    skip +
    "&query=" +
    query;
  const token = getLocalToken();
  if (!token) {
    return;
  }

  const resp = await axios
    .get(getUrl, { headers: { Authorization: token } })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};

export const deletePage = async (key) => {
  const url = getapiurl();
  const aws = "api/layout/";
  const requestName = "/deletePage";
  const getUrl = url + aws + key + requestName;
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const resp = await axios
    .delete(getUrl, { headers: { Authorization: token } })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};

export const getElement = async (pageid) => {
  const api_url = getapiurl() + "api/layout/" + pageid + "/getElement";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const resp = await axios
    .get(api_url, { headers: { Authorization: token } })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });

  return resp;
};

export const editVideoCloud = async (editing) => {
  const api_url = getapiurl() + "api/vcms/" + getAppId() + "/editVideoCloud";
  const token = getLocalToken();
  if (!token) {
    return;
  }

  const token_set = await axios
    .put(
      api_url,
      {
        cloudName: editing.cloudName,
        liveCloudName: editing.liveCloudName,
        cloudKey: editing.cloudKey,
        cloudSecret: editing.cloudSecret,
        cloudKeyV2: editing.cloudKeyV2,
        cloudSecretV2: editing.cloudSecretV2,
        mainAccountId: editing.mainAccountId,
        secondAccountId: editing.secondAccountId,
        firstPlayer: editing.firstPlayer,
        secondPlayer: editing.secondPlayer,
        premiumPlayer: editing.premiumPlayer,
        licenseKey: editing.licenseKey,
        iosLicenseKey: editing.iosLicenseKey || null,
        premLicenseKey: editing.premLicenseKey || null,
        iosPremLicenseKey: editing.iosPremLicenseKey || null,
        secLicenseKey: editing.secLicenseKey || null,
        iosSecLicenseKey: editing.iosSecLicenseKey || null,
        drmKey: editing.drmKey,
        drmMobileKey: editing.drmMobileKey,
        drmTVKey: editing.drmTVKey,
        searchPlaylist: editing.searchPlaylist,
        watchPlaylist: editing.watchPlaylist,
        recommendedPlaylist: editing.recommendedPlaylist,
      },
      { headers: { Authorization: token } }
    )
    .then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};

export const getAllElements = async (limit, skip) => {
  const url = getapiurl();
  const aws = "api/layout/";
  const requestName = "/getAllElements";
  const appid = getAppId();
  const getUrl =
    url + aws + appid + requestName + "?limit=" + limit + "&skip=" + skip;
  const token = getLocalToken();
  if (!token) {
    return;
  }

  const resp = await axios
    .get(getUrl, { headers: { Authorization: token } })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};

export const getAllDashElements = async (limit, skip) => {
  const url = getapiurl();
  const aws = "api/layout/";
  const requestName = "/getDashBoardElements";
  const appid = getAppId();
  const getUrl = url + aws + appid + requestName;
  const token = getLocalToken();
  if (!token) {
    return;
  }

  const resp = await axios
    .get(getUrl, { headers: { Authorization: token } })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};

export const getAllDashPages = async (limit, skip) => {
  const url = getapiurl();
  const aws = "api/layout/";
  const requestName = "/getDashBoardPages";
  const appid = getAppId();
  const getUrl = url + aws + appid + requestName;
  const token = getLocalToken();
  if (!token) {
    return;
  }

  const resp = await axios
    .get(getUrl, { headers: { Authorization: token } })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};
export const getAllElementsByType = async (limit, skip, type) => {
  const url = getapiurl();
  const aws = "api/layout/";
  const requestName = "/getAllElementsByType";
  const appid = getAppId();
  const getUrl =
    url +
    aws +
    appid +
    requestName +
    "?limit=" +
    limit +
    "&skip=" +
    skip +
    "&type=" +
    type;
  const token = getLocalToken();
  if (!token) {
    return;
  }

  const resp = await axios
    .get(getUrl, { headers: { Authorization: token } })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};

export const createMenu = async (editing) => {
  const api_url = getapiurl() + "api/layout/" + getAppId() + "/createMenu";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const token_set = await axios
    .post(
      api_url,
      {
        menuTitle: editing.menuTitle,
        urlName: editing.urlName,
        menuType: editing.menuType,
        menuPage: editing.menuPage,
        menuOrder: editing.menuOrder,
        menuIcon: editing.menuIcon,
      },
      { headers: { Authorization: token } }
    )
    .then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};

export const editMenu = async (editing, id) => {
  const api_url = getapiurl() + "api/layout/" + id + "/editMenu";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const token_set = await axios
    .put(
      api_url,
      {
        menuTitle: editing.menuTitle,
        urlName: editing.urlName,
        menuType: editing.menuType,
        menuPage: editing.menuPage,
        menuOrder: editing.menuOrder,
        menuIcon: editing.menuIcon,
        items: editing.items,
      },
      { headers: { Authorization: token } }
    )
    .then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};

export const publishMenu = async () => {
  const api_url = getapiurl() + "api/publish/" + getAppId() + "/publishMenu";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const token_set = await axios
    .post(api_url, {}, { headers: { Authorization: token } })
    .then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};

export const getMenu = async () => {
  const api_url = getapiurl() + "api/layout/" + getAppId() + "/getfullMenu";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const resp = await axios
    .get(api_url, { headers: { Authorization: token } })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });

  return resp;
};

export const getMenuByID = async (id) => {
  const api_url = getapiurl() + "api/layout/" + id + "/getMenuByID";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const resp = await axios
    .get(api_url, { headers: { Authorization: token } })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });

  return resp;
};

export const deleteMenu = async (key) => {
  const url = getapiurl();
  const aws = "api/layout/";
  const requestName = "/deleteMenu";
  const getUrl = url + aws + key + requestName;
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const resp = await axios
    .delete(getUrl, { headers: { Authorization: token } })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};

export const getLanguages = async () => {
  const api_url =
    getapiurl() + "api/layout/" + getAppId() + "/getLanguageDetail";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const resp = await axios
    .get(api_url, { headers: { Authorization: token } })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });

  return resp;
};

export const addLanguage = async (editing) => {
  const api_url = getapiurl() + "api/layout/" + getAppId() + "/addLanguages";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const token_set = await axios
    .post(api_url, editing, { headers: { Authorization: token } })
    .then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};

export const createTicker = async (editing) => {
  const api_url = getapiurl() + "api/layout/" + getAppId() + "/createTicker";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const token_set = await axios
    .post(
      api_url,
      {
        referenceName: editing.referenceName,
        devices: editing.devices,
        items: editing.items,
        draftStatus: editing.draftStatus,
        publishStatus: editing.publishStatus,
      },
      { headers: { Authorization: token } }
    )
    .then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};

export const editTicker = async (editing, pageid) => {
  const api_url = getapiurl() + "api/layout/" + pageid + "/editTicker";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const token_set = await axios
    .put(
      api_url,
      {
        referenceName: editing.referenceName,
        devices: editing.devices,
        items: editing.items,
        draftStatus: editing.draftStatus,
        publishStatus: editing.publishStatus,
      },
      { headers: { Authorization: token } }
    )
    .then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};

export const getAllTicker = async (limit, skip) => {
  const url = getapiurl();
  const aws = "api/layout/";
  const requestName = "/getAllTicker";
  const appid = getAppId();
  const getUrl =
    url + aws + appid + requestName + "?limit=" + limit + "&skip=" + skip;
  const token = getLocalToken();
  if (!token) {
    return;
  }

  const resp = await axios
    .get(getUrl, { headers: { Authorization: token } })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};

export const getTicker = async (pageid) => {
  const api_url = getapiurl() + "api/layout/" + pageid + "/getTicker";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const resp = await axios
    .get(api_url, { headers: { Authorization: token } })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });

  return resp;
};

export const createTickerPage = async (editing) => {
  const api_url =
    getapiurl() + "api/layout/" + getAppId() + "/createTickerPage";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const token_set = await axios
    .post(
      api_url,
      {
        ticker: editing.ticker,
        page: editing.page,
      },
      { headers: { Authorization: token } }
    )
    .then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};

export const getAllTickerPage = async (limit, skip) => {
  const url = getapiurl();
  const aws = "api/layout/";
  const requestName = "/getAllTickerPage";
  const appid = getAppId();
  const getUrl =
    url + aws + appid + requestName + "?limit=" + limit + "&skip=" + skip;
  const token = getLocalToken();
  if (!token) {
    return;
  }

  const resp = await axios
    .get(getUrl, { headers: { Authorization: token } })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};

export const deleteElement = async (key) => {
  const url = getapiurl();
  const aws = "api/layout/";
  const requestName = "/deleteElement";
  const getUrl = url + aws + key + requestName;
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const resp = await axios
    .delete(getUrl, { headers: { Authorization: token } })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};
export const deleteTickerPage = async (key) => {
  const url = getapiurl();
  const aws = "api/layout/";
  const requestName = "/deleteTickerPage";
  const getUrl = url + aws + key + requestName;
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const resp = await axios
    .delete(getUrl, { headers: { Authorization: token } })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};

export const publishTicker = async (pageid, ticker) => {
  const api_url =
    getapiurl() +
    "api/publish/" +
    getAppId() +
    "/" +
    pageid +
    "/" +
    ticker +
    "/publishTicker";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const token_set = await axios
    .post(api_url, {}, { headers: { Authorization: token } })
    .then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};

export const unpublishTicker = async (pageid, ticker) => {
  const api_url =
    getapiurl() +
    "api/publish/" +
    getAppId() +
    "/" +
    pageid +
    "/" +
    ticker +
    "/unPublishTicker";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const token_set = await axios
    .post(api_url, {}, { headers: { Authorization: token } })
    .then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};

export const getAppUser = async () => {
  const api_url = getapiurl() + "api/user/" + getAppId() + "/getAppUser";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const resp = await axios
    .get(api_url, { headers: { Authorization: token } })
    .then((response) => {
      // If request is good...
      setUserSession(response.data.token);
      return response;
    })
    .catch((error) => {
      removeUserSession();
      throw error;
    });

  return resp;
};
export const changePassword = async (oPassword, nPassword, id) => {
  const api_url = getapiurl() + "api/user/changePassword";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const token_set = await axios
    .post(
      api_url,
      {
        _id: id,
        oldPassword: oPassword,
        newPassword: nPassword,
      },
      { headers: { Authorization: token } }
    )
    .then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};

export const changeSuperPassword = async (nPassword, id) => {
  const api_url = getapiurl() + "api/user/" + id + "/changeSuperPassword";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const token_set = await axios
    .post(
      api_url,
      {
        newPassword: nPassword,
      },
      { headers: { Authorization: token } }
    )
    .then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};
export const getSetting = async () => {
  const api_url = getapiurl() + "api/layout/" + getAppId() + "/getSetting";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const resp = await axios
    .get(api_url, { headers: { Authorization: token } })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};

export const isNecessary = async () => {
  const api_url = getapiurl() + "api/layout/" + getAppId() + "/isNecessary";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const resp = await axios
    .get(api_url, { headers: { Authorization: token } })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};

export const logDetails = async () => {
  const api_id = getAppId();
  const api_url = getapiurl() + "api/layout/" + api_id + "/getLogs";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const resp = await axios
    .get(api_url, { headers: { Authorization: token } })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};

export const getWebSetting = async () => {
  const api_url = getapiurl() + "api/layout/" + getAppId() + "/getWebSetting";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const resp = await axios
    .get(api_url, { headers: { Authorization: token } })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};

export const getAppSetting = async () => {
  const api_url = getapiurl() + "api/layout/" + getAppId() + "/getAppSetting";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const resp = await axios
    .get(api_url, { headers: { Authorization: token } })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};

export const editSetting = async (editing) => {
  const api_url = getapiurl() + "api/layout/" + getAppId() + "/editSetting";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const token_set = await axios
    .put(
      api_url,
      {
        title: editing.title,
        headData: editing.headData,
        domainName: editing.domainName,
        startPage: editing.startPage,
        allowLogin: editing.allowLogin,
        allowSubscription: editing.allowSubscription,
        siteDescription: editing.siteDescription,
        darkMode: editing.darkMode,
        bingeWatching: editing.bingeWatching,
        resumePlayback: editing.resumePlayback,
        socialSharing: editing.socialSharing,
        chromecastID: editing.chromecastID,
        rtl: editing.rtl,
        RFP: editing.RFP,
        multiLanguage: editing.multiLanguage,
        favourites: editing.favourites,
        watchHistory: editing.watchHistory,
        premiumIconVisibility: editing.premiumIconVisibility,
        premiumIcon: editing.premiumIcon,
        production: editing.production,
        gdpr: editing.gdpr,
      },
      { headers: { Authorization: token } }
    )
    .then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};

export const publishSetting = async () => {
  const api_url = getapiurl() + "api/publish/" + getAppId() + "/publishSetting";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const token_set = await axios
    .post(api_url, {}, { headers: { Authorization: token } })
    .then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};

export const createSetting = async (editing) => {
  const api_url = getapiurl() + "api/layout/" + getAppId() + "/createSetting";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const token_set = await axios
    .post(
      api_url,
      {
        title: editing.title,
        headData: editing.headData,
        domainName: editing.domainName,
        startPage: editing.startPage,
        allowLogin: editing.allowLogin,
        allowSubscription: editing.allowSubscription,
        siteDescription: editing.siteDescription,
        darkMode: editing.darkMode,
        bingeWatching: editing.bingeWatching,
        resumePlayback: editing.resumePlayback,
        socialSharing: editing.socialSharing,
        chromecastID: editing.chromecastID,
        rtl: editing.rtl,
        RFP: editing.RFP,
        multiLanguage: editing.multiLanguage,
        favourites: editing.favourites,
        watchHistory: editing.watchHistory,
        premiumIconVisibility: editing.premiumIconVisibility,
        premiumIcon: editing.premiumIcon,
        production: editing.production,
        gdpr: editing.gdpr,
      },
      { headers: { Authorization: token } }
    )
    .then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};

export const createMonetize = async (editing) => {
  const api_url = getapiurl() + "api/layout/" + getAppId() + "/createMonetize";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const token_set = await axios
    .post(
      api_url,
      {
        adTag: editing.adTag,
        adsTxt: editing.adsTxt,
        premiumAd: editing.premiumAd,
        freemiumAd: editing.freemiumAd,
      },
      { headers: { Authorization: token } }
    )
    .then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};

export const publishMonetize = async () => {
  const api_url =
    getapiurl() + "api/publish/" + getAppId() + "/publishMonetize";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const token_set = await axios
    .post(api_url, {}, { headers: { Authorization: token } })
    .then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};

export const createWebSetting = async (editing) => {
  const api_url =
    getapiurl() + "api/layout/" + getAppId() + "/createWebSetting";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const token_set = await axios
    .post(
      api_url,
      {
        numberofMenuItem: editing.numberofMenuItem,
        thumbnailAnimation: editing.thumbnailAnimation,
        loadingSpinner: editing.loadingSpinner,
        deepLink: editing.deepLink,
        cookiePolicy: editing.cookiePolicy,
        shading: editing.shading,
        imageBorder: editing.imageBorder,
        float: editing.float,
        thumbnailDescription: editing.thumbnailDescription,
      },
      { headers: { Authorization: token } }
    )
    .then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};

export const publishWebSetting = async () => {
  const api_url =
    getapiurl() + "api/publish/" + getAppId() + "/publishWebSetting";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const token_set = await axios
    .post(api_url, {}, { headers: { Authorization: token } })
    .then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};

export const createAppSetting = async (editing) => {
  const api_url =
    getapiurl() + "api/layout/" + getAppId() + "/createAppSetting";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const token_set = await axios
    .post(
      api_url,
      {
        actionBarStyle: editing.actionBarStyle,
        androidMinVersion: editing.androidMinVersion,
        iOSMinVersion: editing.iOSMinVersion,
        androidTvMinVersion: editing.androidTvMinVersion,
        appleTvMinVersion: editing.appleTvMinVersion,
        fireTvMinVersion: editing.fireTvMinVersion,
        rokuMinVersion: editing.rokuMinVersion,
        SamsungMinVersion: editing.SamsungMinVersion,
        LGMinVersion: editing.LGMinVersion,
        loadingSpinner: editing.loadingSpinner,
        landscapeOrientation: editing.landscapeOrientation,
        Casting: editing.Casting,
        pip: editing.pip,
        subtitles: editing.subtitles,
        playinSmallWindow: editing.playinSmallWindow,
        imageBorder: editing.imageBorder,
      },
      { headers: { Authorization: token } }
    )
    .then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};

export const publishAppSetting = async () => {
  const api_url =
    getapiurl() + "api/publish/" + getAppId() + "/publishappSetting";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const token_set = await axios
    .post(api_url, {}, { headers: { Authorization: token } })
    .then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};

export const editWebSetting = async (editing) => {
  const api_url = getapiurl() + "api/layout/" + getAppId() + "/editWebSetting";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const token_set = await axios
    .put(
      api_url,
      {
        numberofMenuItem: editing.numberofMenuItem,
        thumbnailAnimation: editing.thumbnailAnimation,
        loadingSpinner: editing.loadingSpinner,
        deepLink: editing.deepLink,
        cookiePolicy: editing.cookiePolicy,
        shading: editing.shading,
        imageBorder: editing.imageBorder,
        float: editing.float,
        thumbnailDescription: editing.thumbnailDescription,
      },
      { headers: { Authorization: token } }
    )
    .then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};

export const editMonetize = async (editing) => {
  const api_url = getapiurl() + "api/layout/" + getAppId() + "/editMonetize";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const token_set = await axios
    .put(
      api_url,
      {
        adTag: editing.adTag,
        adsTxt: editing.adsTxt,
        premiumAd: editing.premiumAd,
        freemiumAd: editing.freemiumAd,
      },
      { headers: { Authorization: token } }
    )
    .then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};

export const editAppSetting = async (editing) => {
  const api_url = getapiurl() + "api/layout/" + getAppId() + "/editAppSetting";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const token_set = await axios
    .put(
      api_url,
      {
        actionBarStyle: editing.actionBarStyle,
        androidMinVersion: editing.androidMinVersion,
        iOSMinVersion: editing.iOSMinVersion,
        androidTvMinVersion: editing.androidTvMinVersion,
        appleTvMinVersion: editing.appleTvMinVersion,
        fireTvMinVersion: editing.fireTvMinVersion,
        rokuMinVersion: editing.rokuMinVersion,
        SamsungMinVersion: editing.SamsungMinVersion,
        LGMinVersion: editing.LGMinVersion,
        loadingSpinner: editing.loadingSpinner,
        landscapeOrientation: editing.landscapeOrientation,
        Casting: editing.Casting,
        pip: editing.pip,
        subtitles: editing.subtitles,
        playinSmallWindow: editing.playinSmallWindow,
        imageBorder: editing.imageBorder,
      },
      { headers: { Authorization: token } }
    )
    .then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};
export const analytics = async (
  fyear,
  fmonth,
  fday,
  tyear,
  tmonth,
  tday,
  editing,
  cloudSecretV2,
  number,
  time,
  selectedUser,
  myArray,
  search,
  gra
) => {
  if (fyear && fmonth && fday && tyear && tmonth && tday) {
    const options = {
      method: "POST",
      headers: {
        accept: "application/json",
        "content-type": "application/json",
        Authorization: cloudSecretV2,
      },
      body: JSON.stringify({
        dimensions: gra === true ? ["media_id", "eastern_date"] : ["media_id"],
        metrics: [
          { operation: "sum", field: "plays" },
          { operation: "sum", field: "ad_impressions" },
          { operation: "sum", field: "completes" },
          { operation: "sum", field: "complete_rate" },
          { operation: "sum", field: "time_watched" },
          { operation: "sum", field: "embeds" },
        ],
        sort: [{ field: "media_id", order: "DESCENDING" }],
        end_date: search === true ? myArray : `${tyear}-${tmonth}-${tday}`,
        start_date:
          search === true ? selectedUser : `${fyear}-${fmonth}-${fday}`,
        page: number,
        relative_timeframe: time || null,
      }),
    };

    try {
      const response = await fetch(
        `https://api.jwplayer.com/v2/sites/${editing}/analytics/queries/?source=default&format=json`,
        options
      );
      if (!response.ok) {
        throw new Error(`Error: ${response.statusText}`);
      }

      const data = await response.json();
      return data;
    } catch (err) {
      console.error("Analytics fetch error:", err);
      return { error: err.message };
    }
  } else {
    throw new Error("Invalid date parameters.");
  }
};

export const editMedia = async (media, edit, edi) => {
  const api_url = getapiurl() + "api/vcms/" + getAppId() + "/getVideoCloud";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const response = await axios
    .get(api_url, { headers: { Authorization: token } })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });

  const options = {
    method: "PATCH",
    headers: {
      accept: "application/json",
      "content-type": "application/json",
      Authorization: response.cloudSecretV2,
    },
    body: JSON.stringify({
      metadata: {
        custom_params: {
          Actor: edi.Actor,
          AssetId: edi.AssetId,
          AudioTracks: edi.AudioTracks,
          ContentType: edi.ContentType,
          Director: edi.Director,
          ExpiresOn: edi.ExpiresOn,
          Genre: edi.Genre,
          MediaType: edi.MediaType,
          MovieId: edi.MovieId,
          PgRating: edi.PgRating,
          Plan: edi.Plan,
          PortraitImage: edi.PortraitImage,
          Producer: edi.Producer,
          ProductionStudio: edi.ProductionStudio,
          Property: edi.Property,
          Rating: edi.Rating,
          Recommendation: edi.Recommendation,
          ReleaseOn: edi.ReleaseOn,
          ReleaseType: edi.ReleaseType,
          ShortDescription: edi.ShortDescription,
          TrailerId: edi.TrailerId,
          VIdeoDuration: edi.VIdeoDuration,
          Writers: edi.Writers,
        },
        title: edit.title,
      },
    }),
  };

  const resp = await fetch(
    "https://api.jwplayer.com/v2/sites/" +
      response.cloudKey +
      "/media/" +
      media +
      "/",
    options
  )
    .then((response) => response.json())
    .then((response) => {
      return response;
    })
    .catch((err) => console.error(err));
  return resp;
};

export const getMedia = async (id) => {
  const api_url = getapiurl() + "api/vcms/" + getAppId() + "/getVideoCloud";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const response = await axios
    .get(api_url, { headers: { Authorization: token } })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
  const options = {
    // method: 'GET',
    headers: {
      accept: "application/json",
      Authorization: response.cloudSecretV2,
    },
  };
  //     // const listItems = media.map(
  //     //   (element) => {

  //     // const media_id =element[0];
  //     //     return media_id;
  //     //   })
  //     for (var i = 0; i< media.length; i++) {
  const url =
    "https://api.jwplayer.com/v2/sites/" +
    response.cloudKey +
    "/media/" +
    id +
    "/";
  const resp = await axios
    .get(url, options)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp.data.metadata;
};

export const logInDetails = async (
  number,
  search,
  selectedUser,
  myArray,
  time,
  SRMSecret,
  uuid
) => {
  const api_v1_url = "https://staging-v2.inplayer.com/";
  const endpoint = "accounts/authenticate";
  const url = api_v1_url + endpoint;
  const form_data = new URLSearchParams();
  form_data.append("client_id", uuid);
  form_data.append("client_secret", SRMSecret);
  form_data.append("grant_type", "client_credentials");
  const getUrl = "https://staging-v2.inplayer.com/payments/transactions";
  const token_set = await axios
    .post(url, form_data, {
      headers: { Accept: "application/x-www-form-urlencoded" },
    })
    .then(
      (response) => {
        return response.data.access_token;
      },
      (error) => {
        throw createHttpError(400, "Invalid Crdentials or UNresponsive API");
      }
    );

  const resp = await axios
    .get(getUrl, {
      headers: { Authorization: `Bearer ${token_set}` },
      params: {
        page: number,
        startDate: search === true ? selectedUser : "",
        endDate: search === true ? myArray : "",
        type: time,
      },
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};

export const getAnalytics = async () => {
  const api_url = getapiurl() + "api/layout/" + getAppId() + "/getTracking";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const resp = await axios
    .get(api_url, { headers: { Authorization: token } })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};

export const createAnalytics = async (editing) => {
  const api_url = getapiurl() + "api/layout/" + getAppId() + "/createTracking";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const token_set = await axios
    .post(
      api_url,
      {
        web: editing.web,
        android: editing.android,
        iOS: editing.iOS,
        androidTv: editing.androidTv,
        appleTv: editing.appleTv,
        fireTv: editing.fireTv,
        roku: editing.roku,
        samsungTizen: editing.samsungTizen,
        lgWebOs: editing.lgWebOs,
        chromecast: editing.chromecast,
        application: getAppId(),
      },
      { headers: { Authorization: token } }
    )
    .then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};

export const publishAnalytics = async () => {
  const api_url =
    getapiurl() + "api/publish/" + getAppId() + "/publishAnalytics";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const token_set = await axios
    .post(api_url, {}, { headers: { Authorization: token } })
    .then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};

export const editAnalytics = async (editing) => {
  const api_url = getapiurl() + "api/layout/" + getAppId() + "/editTracking";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const token_set = await axios
    .put(
      api_url,
      {
        web: editing.web,
        android: editing.android,
        iOS: editing.iOS,
        androidTv: editing.androidTv,
        appleTv: editing.appleTv,
        fireTv: editing.fireTv,
        roku: editing.roku,
        samsungTizen: editing.samsungTizen,
        lgWebOs: editing.lgWebOs,
        chromecast: editing.chromecast,
      },
      { headers: { Authorization: token } }
    )
    .then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};

export const getMonetize = async () => {
  const api_url = getapiurl() + "api/layout/" + getAppId() + "/getMonetize";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const resp = await axios
    .get(api_url, { headers: { Authorization: token } })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};

export const createFooter = async (editing) => {
  const api_url = getapiurl() + "api/layout/" + getAppId() + "/createFooter";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const token_set = await axios
    .post(
      api_url,
      {
        sectionHeader1: editing.sectionHeader1,
        sectionHeader2: editing.sectionHeader2,
        sectionHeader3: editing.sectionHeader3,
        facebookLink: editing.facebookLink,
        youtubeLink: editing.youtubeLink,
        instagramLink: editing.instagramLink,
        twitterLink: editing.twitterLink,
        footDescription: editing.footDescription,
        createdBy: getUserid(),
        editedBy: getUserid(),
        items: editing.items,
      },
      { headers: { Authorization: token } }
    )
    .then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};

export const publishFooter = async () => {
  const api_url = getapiurl() + "api/publish/" + getAppId() + "/publishFooter";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const token_set = await axios
    .post(api_url, {}, { headers: { Authorization: token } })
    .then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};

export const editFooter = async (editing) => {
  const api_url = getapiurl() + "api/layout/" + getAppId() + "/editFooter";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const token_set = await axios
    .put(
      api_url,
      {
        sectionHeader1: editing.sectionHeader1,
        sectionHeader2: editing.sectionHeader2,
        sectionHeader3: editing.sectionHeader3,
        facebookLink: editing.facebookLink,
        youtubeLink: editing.youtubeLink,
        instagramLink: editing.instagramLink,
        twitterLink: editing.twitterLink,
        footDescription: editing.footDescription,
        editedBy: getUserid(),
        items: editing.items,
      },
      { headers: { Authorization: token } }
    )
    .then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};

export const getFooter = async () => {
  const api_url = getapiurl() + "api/layout/" + getAppId() + "/getFooter";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const resp = await axios
    .get(api_url, { headers: { Authorization: token } })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};

export const createFont = async (editing) => {
  const api_url = getapiurl() + "api/layout/" + getAppId() + "/createFont";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const token_set = await axios
    .post(
      api_url,
      {
        selectedFont: editing.selectedFont,
        items: editing.items,
        urlItems: editing.urlItems,
      },
      { headers: { Authorization: token } }
    )
    .then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};

export const publishFont = async () => {
  const api_url = getapiurl() + "api/publish/" + getAppId() + "/publishFonts";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const token_set = await axios
    .post(api_url, {}, { headers: { Authorization: token } })
    .then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};

export const editFont = async (editing) => {
  const api_url = getapiurl() + "api/layout/" + getAppId() + "/editFont";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const token_set = await axios
    .put(
      api_url,
      {
        selectedFont: editing.selectedFont,
        items: editing.items,
        urlItems: editing.urlItems,
      },
      { headers: { Authorization: token } }
    )
    .then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};

export const getFont = async () => {
  const api_url = getapiurl() + "api/layout/" + getAppId() + "/getFont";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const resp = await axios
    .get(api_url, { headers: { Authorization: token } })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};

export const createSubscription = async (editing) => {
  const api_url = getapiurl() + "api/layout/" + getAppId() + "/createSubscribe";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const token_set = await axios
    .post(
      api_url,
      {
        SRMName: editing.SRMName,
        SRMKey: editing.SRMKey,
        SRMSecret: editing.SRMSecret,
        uuid: editing.uuid,
        customLogin: editing.customLogin,
        customLoginUrl: editing.customLoginUrl,
        customPayment: editing.customPayment,
        otp: editing.otp,
        otpKey: editing.otpKey,
        checkoutUrl: editing.checkoutUrl,
        plans: editing.plans,
      },
      { headers: { Authorization: token } }
    )
    .then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};

export const publishSubscription = async () => {
  const api_url =
    getapiurl() + "api/publish/" + getAppId() + "/publishSubscribe";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const token_set = await axios
    .post(api_url, {}, { headers: { Authorization: token } })
    .then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};

export const editSubscription = async (editing) => {
  const api_url = getapiurl() + "api/layout/" + getAppId() + "/editSubscribe";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const token_set = await axios
    .put(
      api_url,
      {
        SRMName: editing.SRMName,
        SRMKey: editing.SRMKey,
        SRMSecret: editing.SRMSecret,
        uuid: editing.uuid,
        customLogin: editing.customLogin,
        customLoginUrl: editing.customLoginUrl,
        customPayment: editing.customPayment,
        otp: editing.otp,
        otpKey: editing.otpKey,
        checkoutUrl: editing.checkoutUrl,
        plans: editing.plans,
      },
      { headers: { Authorization: token } }
    )
    .then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};

export const getSubscription = async () => {
  const api_url = getapiurl() + "api/layout/" + getAppId() + "/getSubscribe";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const resp = await axios
    .get(api_url, { headers: { Authorization: token } })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};

export const getAllUsers = async (limit, skip) => {
  const api_url =
    getapiurl() +
    "api/layout/" +
    getAppId() +
    "/getAllUsers?limit=" +
    limit +
    "&skip=" +
    skip;
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const resp = await axios
    .get(api_url, { headers: { Authorization: token } })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};
export const getRandomInt = (max) => {
  return Math.floor(Math.random() * max);
};
export const getIndex = (a, value) => {
  let index = a.findIndex((x) => x.name === value);
  return index;
};
export const getRealtimeUsers = async (path) => {
  const api_url = getapiurl() + "api/alrayyan/" + path;
  const resp = await axios
    .get(api_url)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};

export const jwplayer = async (
  fyear,
  fmonth,
  fday,
  tyear,
  tmonth,
  tday,
  cloudKey,
  token
) => {
  const options = {
    // method: 'GET',
    headers: {
      accept: "application/json",
      Authorization: token,
    },
  };

  // const date = fyear+'-'+fmonth+'-'+fday+' TO '+tyear+'-'+tmonth+'-'+tday;
  const url =
    "https://api.jwplayer.com/v2/sites/" +
    cloudKey +
    "/media/?page=1&page_length=50&q=created:[" +
    fyear +
    "-" +
    fmonth +
    "-" +
    fday +
    " TO " +
    tyear +
    "-" +
    tmonth +
    "-" +
    tday +
    "]&sort=created%3Adsc";

  const resp = await axios
    .get(url, options)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};

export const jwanalytics = async (
  fyear,
  fmonth,
  fday,
  tyear,
  tmonth,
  tday,
  editing,
  cloudSecretV2
) => {
  let datesCollection = [];
  // const media_id ='qhOv6KCM';
  const opt = {
    method: "POST",
    headers: {
      accept: "application/json",
      "content-type": "application/json",
      Authorization: cloudSecretV2,
    },
    body: JSON.stringify({
      dimensions: ["media_id"],
      metrics: [{ field: "plays", operation: "sum" }],
      sort: [{ field: "plays", order: "DESCENDING" }],
      end_date: tyear + "-" + tmonth + "-" + tday,
      start_date: fyear + "-" + fmonth + "-" + fday,
    }),
  };

  const media = await fetch(
    "https://api.jwplayer.com/v2/sites/" +
      editing +
      "/analytics/queries/?source=default&format=json",
    opt
  )
    .then((response) => response.json())
    .then((response) => {
      return response.data.rows;
    })
    .catch((err) => console.error(err));

  datesCollection.push(media);

  return datesCollection;
};

export const getMedias = async (
  fyear,
  fmonth,
  fday,
  tyear,
  tmonth,
  tday,
  editing,
  cloudSecretV2
) => {
  let datesCollection = [];
  // const media_id ='qhOv6KCM';
  const opt = {
    method: "POST",
    headers: {
      accept: "application/json",
      "content-type": "application/json",
      Authorization: cloudSecretV2,
    },
    body: JSON.stringify({
      dimensions: ["media_id"],
      metrics: [{ field: "plays", operation: "sum" }],
      sort: [{ field: "plays", order: "DESCENDING" }],
      end_date: tyear + "-" + tmonth + "-" + tday,
      start_date: fyear + "-" + fmonth + "-" + fday,
    }),
  };

  const media = await fetch(
    "https://api.jwplayer.com/v2/sites/" +
      editing +
      "/analytics/queries/?source=default&format=json",
    opt
  )
    .then((response) => response.json())
    .then((response) => {
      return response.data.rows;
    })
    .catch((err) => console.error(err));

  const options = {
    // method: 'GET',
    headers: {
      accept: "application/json",
      Authorization: cloudSecretV2,
    },
  };
  // const listItems = media.map(
  //   (element) => {

  // const media_id =element[0];
  //     return media_id;
  //   })
  for (var i = 0; i < media.length; i++) {
    const url =
      "https://api.jwplayer.com/v2/sites/" +
      editing +
      "/media/" +
      media[i][0] +
      "/";
    const resp = await axios
      .get(url, options)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        throw error;
      });
    datesCollection.push(resp.data);
  }
  return datesCollection;
};

export const updates = async (limit, skip) => {
  const url = getapiurl();
  const aws = "api/layout/";
  const requestElement = "/getDashBoardElements";
  const requestPage = "/getDashBoardPages";
  const appid = getAppId();
  const getUrl = url + aws + appid + requestElement;
  const getUrls = url + aws + appid + requestPage;
  const token = getLocalToken();
  let dataCollection = [];
  if (!token) {
    return;
  }

  const resp = await axios
    .get(getUrl, { headers: { Authorization: token } })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
  const response = await axios
    .get(getUrls, { headers: { Authorization: token } })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
  dataCollection.push(response, resp);
  return dataCollection;
};

export const logInDetail = async () => {
  const api_url = getapiurl() + "api/layout/" + getAppId() + "/getSubscribe";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const response = await axios
    .get(api_url, { headers: { Authorization: token } })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });

  const api_v1_url = "https://staging-v2.inplayer.com/";
  const endpoint = "accounts/authenticate";
  const url = api_v1_url + endpoint;
  const form_data = new URLSearchParams();
  form_data.append("client_id", response.uuid);
  form_data.append("client_secret", response.SRMSecret);
  form_data.append("grant_type", "client_credentials");
  // const Url = getapiurl();
  const getUrl =
    "https://staging-v2.inplayer.com/v2/analytics/customers/logins";

  const token_set = await axios
    .post(url, form_data, {
      headers: { Accept: "application/x-www-form-urlencoded" },
    })
    .then(
      (response) => {
        return response.data.access_token;
      },
      (error) => {
        throw createHttpError(400, "Invalid Crdentials or UNresponsive API");
      }
    );

  const resp = await axios
    .get(getUrl, { headers: { Authorization: `Bearer ${token_set}` } })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};

export const analyticsByDate = async () => {
  const api_url = getapiurl() + "api/layout/" + getAppId() + "/getTracking";
  const token = getLocalToken();
  if (!token) {
    return;
  }
  const response = await axios
    .get(api_url, { headers: { Authorization: token } })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });

  const date = () => {
    var day = { day: "numeric" };
    var month = { month: "numeric" };
    var year = { year: "numeric" };
    var Tday = 0 + new Date().toLocaleDateString([], day);
    var Tmonth = 0 + new Date().toLocaleDateString([], month);
    var Tyear = new Date().toLocaleDateString([], year);

    return Tyear + "-" + Tmonth.slice(-2) + "-" + Tday.slice(-2);
  };

  const oneMonth = () => {
    let today = new Date();

    // for(var i =1; i=7;i++)
    // {

    var day = { day: "numeric" };
    var month = { month: "numeric" };
    var year = { year: "numeric" };

    today.setDate(today.getDate() - 7);

    var Fday = 0 + today.toLocaleDateString([], day);
    var Fmonth = 0 + today.toLocaleDateString([], month);
    var Fyear = today.toLocaleDateString([], year);

    return Fyear + "-" + Fmonth.slice(-2) + "-" + Fday.slice(-2);
  };

  const options = {
    method: "POST",
    headers: {
      accept: "application/json",
      "content-type": "application/json",
      Authorization: response.cloudSecretV2,
    },
    body: JSON.stringify({
      dimensions: ["eastern_date"],
      metrics: [
        {
          operation: "sum",
          field: "plays",
        },
        {
          field: "ad_impressions",
          operation: "sum",
        },
        {
          field: "completes",
          operation: "sum",
        },
        {
          field: "complete_rate",
          operation: "sum",
        },
        {
          field: "time_watched",
          operation: "sum",
        },
        {
          field: "embeds",
          operation: "sum",
        },
      ],
      sort: [{ field: "eastern_date", order: "DESCENDING" }],
      end_date: date(),
      start_date: oneMonth(),
      // page: 1,
      relative_timeframe: null,
    }),
  };

  const resp = await fetch(
    "https://api.jwplayer.com/v2/sites/" +
      response.cloudKey +
      "/analytics/queries/?source=default&format=json",
    options
  )
    .then((response) => response.json())
    .then((response) => {
      return response.data;
    })
    .catch((err) => console.error(err));

  return resp;
};

export const analyticsReport = async (
  time,
  fDate,
  tDate,
  sMetrics,
  sDimensions,
  search,
  number,
  limits
) => {
  const api_url = getapiurl() + "api/alrayyan/runTestReport";
  const token = getLocalToken();
  if (!token) {
    return;
  }

  const token_set = await axios
    .post(api_url, {
      startDate:
        search === true
          ? fDate.length !== 0
            ? fDate
            : "30daysAgo"
          : time
            ? time
            : "30daysAgo",
      endDate:
        search === true ? (tDate.length !== 0 ? tDate : "today") : "today",

      dimensions:
        search === true
          ? sDimensions.length === 0
            ? [
                {
                  name: "city",
                },
                {
                  name: "country",
                },
              ]
            : sDimensions
          : [
              {
                name: "country",
              },
              {
                name: "city",
              },
            ],
      metrics:
        search === true
          ? sMetrics.length === 0
            ? [
                {
                  name: "activeUsers",
                },
                {
                  name: "totalUsers",
                },
              ]
            : sMetrics
          : [
              {
                name: "activeUsers",
              },
              {
                name: "totalUsers",
              },
            ],
      orderBys: [
        {
          desc: true,
          dimension: {
            dimensionName:
              search === true
                ? sMetrics.length === 0
                  ? "activeUsers"
                  : sMetrics[0].name
                : "activeUsers",
            // "activeUsers"
          },
        },
      ],
      limit: limits ? limits : null,
      offset: 0,
    })
    .then(
      (response) => {
        return response.data;
      },
      (error) => {
        throw error;
      }
    );
  return token_set;
};
